import styled from "styled-components";
import theme from "../../theme";

export const GlobalWrapper = styled.div`
  width: 100vw;
  overflow-x: hidden;

  background-color: ${theme.colors.background_dark};
`;
